import * as React from "react";
import {cx} from "emotion";

import "./inline-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {Effect}        from "@Common/react/effect";
import {Static}        from "@Common/react/static";
import {Static2}       from "@Common/react/static-2";
import {ModalState}    from "@Common/ui-components/modal-service-3/modal-state";
import {remove1Mutate} from "@Common/utils/collections";

/**
 * 
 */
export const InlineModal = ({rootNext, next: getDisplay}) => cs(
    ["parentAnchorRef", (_, next) => Static2({next})],
    ["targetRefs", (_, next) => Static({initValue: {}, next})],
    ["globalCloses", (_, next) => Static({initValue: [], next})],

    ["local", ({targetRefs, parentAnchorRef, globalCloses}, next) => rootNext({
        parentAnchorRef: parentAnchorRef.set,
        local: (key, localNext) => next({
            next: localNext,
            key,
        }),
        closeAll: () => globalCloses.forEach(v=>v()),
    })],

    ["modalState", ({targetRefs, local}, next) => ModalState({
        next: (modal) => local.next({
            ...modal,
            targetRef: (dom) => targetRefs[local.key] = dom,
        }),
        renderUI: next,
    })],
    ["position"   , ({modalState, parentAnchorRef, targetRefs, local}, next) => Static({
        getInitValue: () => {
            const parentPos = parentAnchorRef.get().getBoundingClientRect();
            const targetPos = targetRefs[local.key].getBoundingClientRect();
            return {
                x: targetPos.x - parentPos.x,
                y: targetPos.y - parentPos.y,
                width : targetPos.width ,
                height: targetPos.height,
            };
        },
        next,
    })],
    ({position, modalState, globalCloses}) => (
        <div
            className={cx(
                "inline-modal inline-modal-594",

                {
                    transitioning: modalState.transitioning.active,
                    "trans-prep": modalState.transitioning.starting,
                    "trans-in-progress": !modalState.transitioning.starting,
                    "trans-entering": modalState.transitioning.toValue,
                    "trans-exiting": !modalState.transitioning.toValue,
                },
            )}
            style={{
                top      : position.y   - 1,
                left     : position.x   - 1,
                width    : position.width  + 2,
                minHeight: position.height + 2,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {Effect({
                action: () => {
                    globalCloses.forEach(v=>v());
                    globalCloses.push(modalState.close);
                    return () => remove1Mutate(globalCloses, modalState.close);
                },
            })}

            <div className="content">
                {getDisplay({params: modalState.params, close: modalState.close})}
            </div>

            <div className="close" xd-qa-type="button" xd-qa-name="Close" onClick={modalState.close}>
                &times;
            </div>
        </div>
    ),
);
